import Http from '@/api/http.js'

export default {
  indexPrintInternalPayment(filter){
    return Http.get(`driver_internal_payments/print`, {
      params: {
        ...filter
      }
    });
  },

  index(filter){
    return Http.get(`/internal_payments`, {
      params: {
        ...filter
      }
    });
  },

  showInternalPayment(id){
    return Http.get(`internal_payments/${id}`);
  },

  create(new_internal_payment){
    return Http.post(`internal_payments`, {
      internal_payment:{
        ...new_internal_payment
      }
    })
  },
  createWithDriverId(new_internal_payment, driver_id){
    return Http.post(`internal_payments`, {
      internal_payment:{
        ...new_internal_payment
      },
      params:{
        driver_id
      }
    })
  },

  updateWithFormData(internal_payment){
    return Http.put(`/internal_payments/${internal_payment.get('internal_payment[id]')}`, internal_payment);
  },
}